<template>
<div class="reservation-modal">
    <v-row>
        <v-col cols="6">
            <v-row class="nowrap" align="center">
                <v-col cols="12" md="6">
                    <v-skeleton-loader v-if="loading_item" class="mx-auto" type="list-item-three-line"></v-skeleton-loader>
                    <div v-else :class="{'pl-4': $vuetify.breakpoint.mdAndUp, 'pl-2': $vuetify.breakpoint.smAndDown }">
                        <div class="detail">
                            {{ getDate(item.timestamp) }} {{ getTime(item.timestamp) }}
                        </div>
                        <div class="important font-weight-bold">
                            {{ item.id }}
                        </div>
                        <div v-if="checkQTravelDetail(item)">
                            <span class="regular font-weight-bold">
                                <v-avatar size="16">
                                    <img :src="q_img">
                                </v-avatar>
                                {{ item.client_observations | getQTravelDetail }}
                            </span>
                        </div>
                    </div>
                </v-col>
                <v-col cols="12" md="6">
                    <v-skeleton-loader v-if="loading_item" class="mx-auto" type="list-item-two-line"></v-skeleton-loader>
                    <div v-else :class="{'pl-4': $vuetify.breakpoint.mdAndUp, 'pl-2': $vuetify.breakpoint.smAndDown, 'regular': true }">
                        <div :class="item.status">{{ item.status }}</div>
                        <div v-if="item.hotel_contact.test" class="red--text regular font-weight-bold">Test</div>
                    </div>
                </v-col>
            </v-row>
        </v-col>
        <v-col cols="6">
            <v-row align="center">
                <v-col cols="12" md="6" fill-height>
                    <v-skeleton-loader v-if="loading_item" class="mx-auto" type="list-item-three-line"></v-skeleton-loader>
                    <im-period v-else :check_in="getDate(item.check_in)" :check_out="getDate(item.check_out)" />
                </v-col>
                <v-col cols="12" md="6" class="text-center">
                    <v-skeleton-loader v-if="loading_item" class="mx-auto" type="list-item-three-line"></v-skeleton-loader>
                    <template v-else>
                        <div class="faded">{{item.nights}}N X {{item.rooms}}R= {{item.rooms_nights}}RN</div>
                        <div class="faded">{{item.pax.adults}} adulti<span> + {{ getChildren(item.pax) }} copii</span></div>
                        <im-price :price="item.pricing.total" :currency="item.pricing.currency" />
                    </template>
                </v-col>
            </v-row>
        </v-col>
    </v-row>

    <v-divider />

    <v-row>
        <v-col cols="12" md="6">
            <v-row>
                <v-col cols="4" class="pa-1">
                    <v-skeleton-loader v-if="loading_item" class="mx-auto" type="image"></v-skeleton-loader>
                    <template v-else>
                        <v-img v-if="item.hotel_contact.image" :src="item.hotel_contact.image"></v-img>
                    </template>
                </v-col>
                <v-col cols="8">
                    <v-skeleton-loader v-if="loading_item" class="mx-auto" type="article"></v-skeleton-loader>
                    <template v-else>
                        <div class="important">
                            {{ item.hotel_contact.name }}
                        </div>
                        <div class="regular">
                            <span>{{ item.hotel_contact.city }}</span><span v-if="item.hotel_contact.region">,{{ item.hotel_contact.region }}</span>
                        </div>
                        <div class="regular">
                            {{ item.hotel_contact.phone }}
                        </div>
                        <div class="regular">
                            {{ item.hotel_contact.email }}
                        </div>
                    </template>
                </v-col>
            </v-row>
        </v-col>

        <v-divider v-if="$vuetify.breakpoint.smAndDown" />

        <v-col cols="12" md="6">
            <div>
                <v-skeleton-loader v-if="loading_item" type="heading,list-item-two-line"></v-skeleton-loader>
                <template v-else>
                    <div>
                        <div class="important">
                            {{ item.client_contact.first_name }} {{ item.client_contact.last_name }}
                        </div>
                        <div class="regular">
                            {{ item.client_contact.contact.address.city }},{{ item.client_contact.contact.address.region }}
                        </div>
                        <div class="regular">
                            {{ item.client_contact.contact.phone }}
                        </div>
                        <div class="regular">
                            {{ item.client_contact.email }}
                        </div>
                    </div>
                </template>

                <v-divider v-if="item.is_agency" />

                <v-skeleton-loader class="mt-1" v-if="loading_item" type="heading,sentences"></v-skeleton-loader>
                <template v-else>
                    <div>
                        <span class="faded" v-if="item.is_agency">Rezervare facuta prin agentie</span>
                        <div class="important">
                            {{ item.agency.name }}
                        </div>
                        <div class="regular">
                            {{ item.agency.city }}
                        </div>
                        <div class="regular">
                            {{ item.agency.phone }}
                        </div>
                        <div class="regular">
                            {{ item.agency.email }}
                        </div>
                    </div>
                </template>
            </div>
        </v-col>
    </v-row>

    <v-divider />

    <v-row class="nowrap py-2" no-gutters>
        <v-col cols="12" md="6">
            <v-skeleton-loader v-if="loading_item" type="heading,list-item-two-line"></v-skeleton-loader>
            <template v-else>
                <div>
                    <span v-if="item.nights == 1">1 noapte</span>
                    <span v-else>{{ item.nights }} nopti</span>
                </div>
                <v-row class="py-1" v-for="(room, index) in unique_rooms" :key="'asd_'+index" no-gutters>
                    <v-col cols="7">
                        <div class="important">
                            {{ room.count }} X {{ room.room_type.name }}
                            <span class="">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <template v-if="room.pax.adults < 3 ">
                                            <span v-for="(adult, index) in room.pax.adults" :key="'adult_'+index">
                                                <v-icon v-on="on" size="24">person</v-icon>
                                            </span>
                                        </template>
                                        <template v-else>
                                            <span>
                                                <v-icon v-on="on" size="24">person</v-icon>X{{ room.pax.adults }}
                                            </span>
                                        </template>
                                    </template>
                                    <div>
                                        <div v-if="room.pax.adults" class="px-1">{{ room.pax.adults }} adults</div>
                                    </div>
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <template v-if="getChildren(room.pax) >0">
                                            <template v-if="getChildren(room.pax)< 3 ">
                                                <span v-on="on" v-for="(child, index) in getChildren(room.pax)" :key="index">
                                                    <v-icon size="18">person</v-icon>
                                                </span>
                                            </template>
                                            <template v-else>
                                                <span v-on="on" class="regular">
                                                    <v-icon size="18">person</v-icon>X{{ getChildren(room.pax)}}
                                                </span>
                                            </template>
                                        </template>
                                    </template>
                                    <div>
                                        <div v-if="room.pax.infants" class="px-1">{{room.pax.infants}} infants</div>
                                        <div v-if="room.pax.small_children" class="px-1">{{room.pax.small_children}} small children</div>
                                        <div v-if="room.pax.big_children" class="px-1">{{room.pax.big_children}} big children</div>
                                    </div>
                                </v-tooltip>
                            </span>
                        </div>
                        <div class="regular">
                            {{ room.rate_plan.name }}
                        </div>
                    </v-col>
                    <v-col cols="5">
                        <div class="d-flex justify-end">
                            <div class="d-flex justify-end" v-if="!room.show">
                                <span v-if="(!isNew(room.price[0].amount)&&(item.nights > 1))" class="font-weight-bold regular">{{item.nights}}Nx</span>
                                <span class="font-weight-bold regular pr-1">{{ room.count }} </span> x
                                <im-price :price="room.total_price.amount" :currency="room.total_price.currency" class="pl-1" />
                            </div>
                            <div v-if="room.show">
                                <div class="d-flex justify-space-between" v-for="(price_day, index2) in room.price" :key="index2">
                                    <div class="detail pr-1">{{ getDayAndMonth(price_day.date) }}</div>
                                    <div class="d-flex justify-end fill-height">
                                        <span class="font-weight-bold detail pr-1">{{ room.count }} x</span>
                                        <im-price v-if="isNew(price_day.amount)" :price="price_day.amount" :currency="price_day.currency" fontSize="12" />
                                        <im-price v-else :price="room.total_price.amount" :currency="price_day.currency" fontSize="12" />
                                    </div>
                                </div>
                            </div>
                            <v-icon v-if="!room.show" @click="showDays(index)" style="align-self: end">keyboard_arrow_down</v-icon>
                            <v-icon v-if="room.show" @click="showDays(index)" style="align-self: flex-end">keyboard_arrow_up</v-icon>
                        </div>
                    </v-col>
                </v-row>
            </template>
        </v-col>
        <v-divider v-if=" $vuetify.breakpoint.smAndDown">
        </v-divider>
        <v-col cols="12" md="6">
            <v-skeleton-loader v-if="loading_item" type="list-item-three-line"></v-skeleton-loader>
            <template v-else>
                <div class="pb-1">
                    <div class="faded">
                        Observatii client:
                    </div>
                    <div class="regular">
                        {{ item.client_observations }}
                    </div>
                </div>
                <div v-if="$vuetify.breakpoint.mdAndUp" style="position: relative;margin-bottom: 20px;">
                    <div class="faded">
                        Politica de anulare
                    </div>
                    <div :class="{'regular': true,'description':true,'more':show_more}" v-if="item.cancellation_policy">
                        {{ item.cancellation_policy.ro }}
                    </div>
                    <div class="regular description" v-else>
                        -
                    </div>
                    <v-btn color="primary" small text absolute right @click="show_more = !show_more" class="nodisplay">
                        <span v-if="!show_more">Show more</span>
                        <span v-else>Show less</span>
                    </v-btn>
                </div>
            </template>
        </v-col>
    </v-row>

    <v-divider />

    <v-row wrap v-if="item.is_agency" class="nowrap" no-gutters>
        <v-col sm="6" cols="12">
            <v-skeleton-loader v-if="loading_item" type="heading,list-item-two-line"></v-skeleton-loader>
            <template v-else>
                <div class="py-1">
                    <div class="faded">Hotelul trebuie sa emita factura catre:</div>
                    <div class="important">{{ item.invoice.organization_name }}</div>
                    <div class="regular">{{ item.invoice.fiscal_code }}</div>
                    <div class="regular">{{ item.invoice.registry_number }}</div>
                    <div class="regular">{{ item.invoice.address.street }}, {{ item.invoice.address.region }}</div>
                </div>
            </template>
        </v-col>
        <v-col sm="6" cols="12">
            <v-skeleton-loader v-if="loading_item" type="heading,list-item-two-line"></v-skeleton-loader>

            <div class="py-1" v-else>
                <v-row v-if="checkQTravelDetail(item)" no-gutters>
                    <v-col cols="9">Valoare Totala</v-col>
                    <v-col cols="3" class="text-right">
                        <im-price :price="item.agency.commissioning.agency.commissionable_value" :currency="item.agency.commissioning.agency.currency" />
                    </v-col>
                </v-row>
                <v-row v-if="!checkQTravelDetail(item)" no-gutters>
                    <v-col cols="9">Valoare de facturat</v-col>
                    <v-col cols="3" class="text-right">
                        <im-price :price="item.invoice.price" :currency="item.invoice.currency" />
                    </v-col>
                </v-row>
                <div class="blue pa-2 white--text my-1 text-center" v-if="!checkQTravelDetail(item)">
                    <v-icon color="white" class="px-2 ">info</v-icon>
                    <span> HelloRomania va factura aceasta factura la inceputul lunii urmatoare.</span>
                </div>
                <v-row no-gutters>
                    <v-col cols="9">Procent Comision</v-col>
                    <v-col cols="3">
                        <div class="font-weight-bold text-right">
                            {{ item.agency.commissioning.agency.commission_percentage}} %
                        </div>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="9">Valoare Comision</v-col>
                    <v-col cols="3" class="text-right">
                        <im-price :price="item.agency.commissioning.agency.commission_value" :currency="item.agency.commissioning.agency.currency" />
                    </v-col>
                </v-row>
                <v-row no-gutters v-if="checkQTravelDetail(item)">
                    <v-col cols="9">Valoare de facturat</v-col>
                    <v-col cols="3" class="text-right">
                        <im-price :price="item.invoice.price" :currency="item.invoice.currency" />
                    </v-col>
                </v-row>
                <div class="blue pa-2 white--text my-1 text-center" v-if="checkQTravelDetail(item)">
                    <v-icon color="white" class="px-2">info</v-icon>
                    <span>HelloRomania nu va factura aceasta factura.</span>
                </div>

            </div>

        </v-col>
    </v-row>
    <v-divider v-if="$vuetify.breakpoint.smAndDown"></v-divider>
    <template v-if="$vuetify.breakpoint.smAndDown">
        <div class="py-1">
            <div class="faded">Politica de anulare</div>
            <div class="regular" v-if="item.cancellation_policy">{{ item.cancellation_policy.ro }}</div>
            <div v-else class="regular">-</div>
        </div>
    </template>
    <div v-if="show_comments">
        Comments for reservation <span class="font-weight-bold">{{ item.id }}</span>
    </div>
    <im-comment v-if="show_comments" :items="comments_reservation"></im-comment>

</div>
</template>

<script>
import defaults from "../utils/PropDefaults.js";
import IMComments from './Comments.vue';
import IMPeriod from '../small-components/IMPeriod.vue';
import IMPrice from '../small-components/IMPrice.vue';
import QImg from '../../assets/q-travel.svg';

export default {
    components: {
        'im-period': IMPeriod,
        'im-price': IMPrice,
        'im-comment': IMComments
    },

    props: {
        item_id: [Number, String],
        comments: {
            type: Number,
            default: 0
        },
        show_comments: {
            type: Boolean,
            default: false

        }
    },

    data: () => {
        return {
            comments_reservation: [],
            unique_rooms: [],

            q_img: QImg,
            loading_item: false,
            show_more: false,
            show_total: true,
            item: defaults.reservation_item
        }
    },


    filters: {
        getQTravelDetail(value) {
            let myReg = /[CDA]+([0-9]{1,6})/g;
            return myReg.exec(value)?.[1];
        },
    },

    mounted() {
        this.getItem();
    },

    watch: {
        item_id: {
            handler() {
                this.getItem()
            }
        },
    },

    methods: {

        getDate(date) {
            if(!date) return date;
            let value = date * 1000;
            return this.$moment(value)
                .format('YYYY-MM-DD');
        },
        getDayAndMonth(date) {
            if(!date) return date;
            return this.$moment(date)
                .format('DD.MMM');
        },

        getTime(date) {
            if(!date) return date;
            let value = date * 1000;
            return this.$moment(value)
                .format('HH:mm:ss');
        },

        getItem() {
            if(!this.item_id) {
                return
            }
            this.loading_item = true;
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/admin/reservations/" + this.item_id;

            this.$axios.get(endpoint)
                .then(response => {
                    this.item = response.data;
                    this.getComments(response.data.id);
                    let rooms = this.item.room_types;
                    let _unArray = [];
                    rooms.forEach(function (item) {
                        let isPresent = _unArray.filter(function (elem) {
                            return JSON.stringify({ ...elem
                            }) == JSON.stringify({ ...item
                            })
                        })
                        if(isPresent.length == 0) {
                            _unArray.push(item)
                        }
                    })
                    _unArray.forEach(function (unique) {
                        let isPresent = rooms.filter(function (elem) {
                            return JSON.stringify({ ...unique
                            }) == JSON.stringify({ ...elem
                            })
                        })
                        unique.show = false;
                        unique.count = isPresent.length;
                    })
                    this.unique_rooms = this.$clone(_unArray);
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {
                    this.loading_item = false;
                });
        },

        checkQTravelDetail(reservation) {
            if (reservation?.channel === 'Q-Travel') {
                return true;
            }

            let myReg = /[CDA]+([0-9]{1,6})/g;
            return myReg.test(reservation.client_observations);
        },

        getCurrency(value) {
            if(value === undefined) {
                return null
            } else {
                return value
            }
        },

        getNights(value) {
            let nights = value.length;
            return nights
        },

        getChildren(pax) {
            let children = pax.infants + pax.small_children + pax.big_children;
            return children
        },

        showDays(index) {
            this.unique_rooms[index].show = !this.unique_rooms[index].show;
        },

        getComments(value) {
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/comments/comments";

            // setup query params
            let params = {
                params: {
                    // resource_owner: this.resource_owner,
                    // resource_type: this.resource_type,
                    resource_id: value
                }
            };
            // make get request
            this.$axios.get(endpoint, params)
                .then(response => {
                    this.comments_reservation = response.data.data;
                    this.allComments(response.data.data.length);
                })
                .catch(error => {
                    console.log(error);
                });

        },
        allComments(value) {
            this.$emit('all_comments', value);
        },

        emitClick() {
            this.$emit('click');
        },

        isNew(value) {
            if(value === 0 || value === "0") {
                return false
            } else {
                return true
            }
        },
    },


}
</script>

<style>
.reservation-modal .booked {
    border-style: none;
    text-transform: capitalize;
    color: #4CAF50;
    font-size: 14px;
    font-weight: 700;
}

.reservation-modal .no-show {
    border-style: none;
    text-transform: capitalize;
    color: #FFC107;
    font-size: 14px;
    font-weight: 700;
}

.reservation-modal .canceled {
    border-style: none;
    text-transform: capitalize;
    color: #F44336;
    font-size: 14px;
    font-weight: 700;
}

.reservation-modal .flag-test {
    text-transform: capitalize;
    color: red;
}

.reservation-modal .price {
    font-size: 16px;
    color: #4a4a4a;
}

.description {
    padding-bottom: 15px;
    line-height: 15px;
    max-height: 45px;
    overflow: hidden;
}

.description.more {
    max-height: 100%;
    height: 100%;
}
</style>
